/**
 * @author Kumaravel Pazhani
 * @email kumaravel@qdmplatforms.com
 * @create 24/08/2021
 * @modify 24/08/2021
 * @desc Exporting all the components from /src/components
 */

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { TextField, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import SearchIcon from "@material-ui/icons/Search";

const useStyles = (theme) => ({
    selectBoxWithText: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "7px",
            padding: "9px 9px 9px 19px"
        },
    },
    withtext: {
        position: "absolute",
        paddingLeft: 7,
        color: "#9696A9",
        zIndex: 4,
        paddingTop: 12,
        fontSize: 13
    },
    selectBox: {
        width: "100%",
        height: "35px",
        "& .MuiOutlinedInput-root": {
            borderRadius: "7px",
        },
        "& .MuiFormLabel-root.Mui-focused": {
            transform: "translate(14px, -6px) scale(0.75) !important",
        },
        "& .MuiFormLabel-root.MuiInputLabel-shrink": {
            transform: "translate(14px, -6px) scale(0.75) !important",
        },
        "& .MuiInputLabel-outlined": {
            transform: "translate(14px, 9px) scale(1) !important",
        },
        "& .MuiAutocomplete-inputRoot": {
            height: "35px",
            "& input": {
                padding: "0.5px 4px !important",
            },
        },
        "& .MuiAutocomplete-tag": {
            margin: "3px -4px 3px 8px",
            height: "25px",
            fontSize: "0.8rem"
        }
    },
    MultiselectBox: {
        width: "100%",
        // height: "35px",
        "& .MuiAutocomplete-inputRoot": {
            "& input": {
                padding: "0.5px 4px !important",
            },
        },
        "& .MuiAutocomplete-tag": {
            margin: "3px -4px 3px 8px",
            height: "25px",
            fontSize: "0.8rem"
        }
    }
});

class SelectBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        let {
            withText,
            Optionlabel = "label",
            placeholder,
            classes,
            onchange,
            classname,
            list,
            value,
            title,
            top_title,
            multi,
            disableClearable,
            requireStart,
            parent_id
        } = this.props;
        return (
            <React.Fragment>
                {top_title && <Typography
                    id={`${parent_id}_select_${top_title.replace(" ", "_")}_typography`}
                    variant="caption">{top_title}{requireStart && <span
                        id={`${parent_id}_select_${top_title}_star_span`}
                        style={{
                            color: 'red',
                            marginLeft: 5
                        }}>*</span>}</Typography>}
                {withText ? (<React.Fragment>
                    <Typography className={classes.withtext}>{withText}</Typography>
                    <Autocomplete
                        id={`${parent_id}_select_autocomplete`}
                        multiple={multi}
                        options={list}
                        className={`${classes.selectBoxWithText} ${classes.selectBox} ${value ? "Mui-focused" : ""} ${classname ? classname : ""
                            }`}
                        onChange={onchange}
                        getOptionLabel={(option) => option[Optionlabel]}
                        style={{ width: "100%", height: "35px", marginTop: "4px" }}
                        value={value}
                        renderInput={(params) => (
                            <TextField
                                id={`${parent_id}_select_textfield`}
                                style={{ height: "35px", background: "white", borderRadius: "9px" }}
                                placeholder={placeholder}
                                {...params}
                                label={top_title ? "" : title}
                                variant="outlined"
                            />
                        )}
                    />
                </React.Fragment>
                ) : (
                    <Autocomplete
                        id={`${parent_id}_select_disableClearable_autocomplete`}
                        multiple={multi}
                        disableClearable={disableClearable}
                        options={list}
                        className={`${multi ? classes.MultiselectBox : classes.selectBox} ${value ? "Mui-focused" : ""} ${classname ? classname : ""
                            }`}
                        onChange={onchange}
                        getOptionLabel={(option) => option[Optionlabel]}
                        style={{ width: "100%", height: multi ? "" : "35px", marginTop: "4px" }}
                        value={value}
                        renderInput={(params) => (
                            <TextField
                                id={`${parent_id}_select_disableClearable_textfield`}
                                style={{ height: multi ? "" : "35px", background: "white", borderRadius: "9px" }}
                                placeholder={placeholder}
                                {...params}
                                label={top_title ? "" : title}
                                variant="outlined"
                            />
                        )}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default withStyles(useStyles)(SelectBox);
